// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__Uo3zQ","col":"styles_col__3o330","fulfillmentStatus":"styles_fulfillmentStatus__1g_iC","emailCol":"styles_emailCol__3ebkC"};